import { createContext } from "react";

const ActiveSongContext = createContext({
  activeSongTitle: "",
  setActiveSongTitle: () => {},
  activeCatalogTitle: "",
  setActiveCatalogTitle: () => {},
});

export default ActiveSongContext;
